<template>
  <div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
const roomName = '/cuenta-';
export default {
  name: 'CuentasListenerComponent',
  data () {
    return {
      roomNameFull: null,
    }
  },
  mounted () {
    // this.onUnirRoom()
  },
  created () {
    this.$root.$on('update:cuenta', this.onUpdateCuenta)
    this.$root.$on('update:sucursal_id', this.onUpdateSucursalId)
  },
  beforeDestroy () {
    this.$root.$off('update:cuenta', this.onUpdateCuenta)
    this.$root.$off('update:sucursal_id', this.onUpdateSucursalId)
    this.onLiberar()
    // this.onLiberarRoom()
  },
  computed: {
    ...mapGetters('Cuentas', ['selected', 'filters']),
    cuentaSelected () {
      return this.selected && this.selected.id > 0
    },
    cuentaId () {
      return this.selected.id
    },
  },
  watch: {
    cuentaId (newValue) {
      // this.$store.commit('Saldos/setFilters', {
      //   ...this.$store.getters['Saldos/filters'],
      //   cuenta_id: newValue && newValue > 0? newValue : null
      // })
      // this.$store.commit('Transacciones/setFilters', {
      //   ...this.$store.getters['Transacciones/filters'],
      //   cuenta_id: newValue,
      // })
      if (newValue) {
        // Llama a una función para cargar los datos iniciales de la pestaña activa
        // this.$store.dispatch('Saldos/onFetch').then(response => {
        //   if(response.length > 0) {
        //     this.$store.commit('Saldos/setSelected', {
        //       ...this.$store.getters['Saldos/selected'],
        //       id: response[0].id,
        //       periodo: response[0].periodo,
        //       precio_subsidio: response[0].precio_subsidio,
        //       precio_usuario: response[0].precio_usuario,
        //       precio_pleno: response[0].precio_pleno,
        //       subsidio: response[0].subsidio,
        //       usuario: response[0].usuario,
        //       pleno: response[0].pleno,
        //       consumido: response[0].consumido,
        //       cuenta_id: response[0].cuenta_id,
        //       precio_id: response[0].precio_id,
        //       created_at: response[0].created_at,
        //       updated_at: response[0].updated_at
        //     })
        //     this.$store.commit('Transacciones/setFilters', {
        //       ...this.$store.getters['Transacciones/filters'],
        //       cuenta_saldo_id: response[0].id
        //     })
        //   }
        // })
      }
      else {
        this.$store.dispatch('Transacciones/onClearAll')
        this.$store.dispatch('Saldos/onClearAll')
      }
    },
    onUpdateCuenta (newValue) {
      this.$store.dispatch('Cuentas/onRefresh');
    }
  },
  methods: {
    ...mapMutations('Transacciones', ['setFilters']),
    onUnirRoom () {
      this.roomNameFull = roomName + this.$store.getters['Cuentas/selected'].id
      this.$socket.on(this.roomNameFull, (response) => {
        this.onFetch()
      });
    },
    onLiberarRoom () {
      this.$socket.off(this.roomNameFull);
    },
    onLiberar() {
      this.$store.dispatch('Transacciones/onClearAll')
    },
    onUpdateSucursalId() {
      //CUENTAS
      this.$store.dispatch('Cuentas/onClearEdited')
      this.$store.dispatch('Cuentas/onClearSelected')
      this.$store.dispatch('Cuentas/onClearFilters')
      this.$store.dispatch('Cuentas/onClearAll')
      //TRANSACCIONES
      this.$store.dispatch('Transacciones/onClearEdited')
      this.$store.dispatch('Transacciones/onClearSelected')
      this.$store.dispatch('Transacciones/onClearFilters')
      this.$store.dispatch('Transacciones/onClearAll')
      //CUENTAS SALDOS
      this.$store.dispatch('Saldos/onClearSelected')
      this.$store.dispatch('Saldos/onClearFilters')
      this.$store.dispatch('Saldos/onClearAll')
    }
  }
}
</script>
